// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2uIA0","inputWrap":"Table_inputWrap__1wlSs","col":"Table_col__bH4MY","bmiTooltip":"Table_bmiTooltip__2N6Gt"};